import React from 'react';
import { Col, Popover, Row } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

const title = (
    <div className='portfolio_popover_title'>
      Services Overview
    </div>
  );

const content = (
  <Row gutter={[0, 8]} justify="center" style={{ textAlign: 'center' , flexDirection:'column'}}>
    <Col span={4}>
      <a
        href="https://drive.google.com/uc?export=download&id=1MeHmPUfbSYt3csT4eplyb9yxUXA9LotW"
        target="_blank"
        rel="noopener noreferrer"
        className='portfolio_popover_link'
      >
        <DownloadOutlined style={{ marginRight: '8px' }} />
        Architecture
      </a>
    </Col>
    <Col span={4}>
      <a
        href="https://drive.google.com/uc?export=download&id=1addv1EZ6aq_iBaIBz59w0QG8W54YMQq6"
        target="_blank"
        className='portfolio_popover_link'
        rel="noopener noreferrer"
      >
        <DownloadOutlined style={{ marginRight: '8px' }} />
        Engineering
      </a>
    </Col>
    <Col span={4} hidden>
      <a
        href="https://drive.google.com/uc?export=download&id=YOUR_CONSTRUCTION_ID"
        target="_blank"
        className='portfolio_popover_link'
        rel="noopener noreferrer"
      >
        <DownloadOutlined style={{ marginRight: '8px' }} />
        Construction
      </a>
    </Col>
  </Row>
);

const PortfolioPopover = () => (
  <Popover 
    content={content}  
    title={title} 
    placement="bottom" 
    trigger="click"
    style={{maxWidth:'fit-content'}}
    >
    <button
      type="button"
      className="btn btn-outline-light btn-lg mx-0 mx-sm-2 my-2 my-sm-0"
    >
      <DownloadOutlined style={{ marginRight: '8px' }} />
      Portfolio
    </button>
  </Popover>
);

export default PortfolioPopover;
